import { FC } from 'react';
import { Claims } from '@/_shared/constants';
import { BetaExpiringBanner } from '@/billing/components/BetaExpiringBanner';
import { PaymentFailedBanner } from '@/billing/components/PaymentFailedBanner';
import { SubscriptionMissingBanner } from '@/billing/components/SubscriptionMissingBanner';
import { TrialExpiringBanner } from '@/billing/components/TrialExpiringBanner';
import { ClaimsComponent } from '../Claims';

/**
 * HeadlessBanners centralizes all headless banner components used by the application layout.
 *
 * Headless banners do not render UI directly in their own position. Instead, they use the
 * layout banner context to inject or remove banner nodes inside `PageLayout`, typically between
 * the page header and the main content area.
 *
 * This component is consumed by `PageLayout`, so every banner registered here becomes available
 * across all pages that use the application layout.
 *
 * Add new global or layout-level headless banners here to keep their registration in one place.
 *
 * @example
 * // Consumed inside PageLayout
 * <LayoutContext.Provider value={...}>
 *   <HeadlessBanners />
 *   ...
 * </LayoutContext.Provider>
 */
export const HeadlessBanners: FC = () => {
  return (
    <>
      <ClaimsComponent claimKey={Claims.BILLING_WRITE}>
        <TrialExpiringBanner />
      </ClaimsComponent>
      <ClaimsComponent claimKey={Claims.BILLING_WRITE}>
        <PaymentFailedBanner />
      </ClaimsComponent>
      <ClaimsComponent claimKey={Claims.BILLING_WRITE}>
        <BetaExpiringBanner />
      </ClaimsComponent>
      <ClaimsComponent claimKey={[Claims.BILLING_READ, Claims.BILLING_WRITE]}>
        <SubscriptionMissingBanner />
      </ClaimsComponent>
    </>
  );
};
